<template>
  <div class="copies">

    <navbar></navbar>

    <h1>Copies</h1>
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th>Text</th>
          <th>Location</th>
          <th>Signature</th>
          <th>Consulted</th>
          <th># User traces</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="copy in copies">
          <td>{{copy.Text}}</td>
          <td>{{copy.Location}}</td>
          <td>{{copy.Signature}}</td>
          <td>{{copy.Consulted}}</td>
          <td>{{copy.NumberOfUserstraces}}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>

import navbar from '@/components/navbar.vue';

export default {
  name: 'copies',
  data () {
    return {
      copies : []
    }
  },
  methods: {
    // Load employee-data form webserivce
    loaddata: function () {
      this.$http.post('pCopyList').then(function(response) { this.copies = response.data; });
    },
    open: function (slug) {
      this.$router.push({ name: "Copy", params: { slug: slug }});
    }
  },
  components: {
    'navbar': navbar
  },
  created: function() {
					this.loaddata();
        }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// copies.vue?020cbb0b